import { useQuery } from "@tanstack/react-query";

import { getSubscriptionHistory } from "../api/subscriptionApi";

/**
 * Hook to fetch subscription request history
 */
export const useSubscriptionHistory = (options = {}) => {
  return useQuery({
    queryKey: ["subscription", "history"],
    queryFn: getSubscriptionHistory,
    staleTime: 60 * 60 * 1000, // 1 hour
    ...options,
  });
};
